// @flow
import { TOUR_PRACTICAL_INFORMATION } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_TOUR_PRACTICAL_INFO } from 'Utils/request/requestDictionary';

export type TourPracticalInformationDescriptorProps = {
  healthFormalities: string,
  immigrationFormalities: string,
  includedInTour: string,
  notIncludedInTour: string,
  resortId: string,
};

export const tourPracticalInformationResolver = {
  name: TOUR_PRACTICAL_INFORMATION,
  resolve(appContext: AppContext, props: TourPracticalInformationDescriptorProps) {
    const { resortId: productId } = props;
    const query = `query {
      resort(resortId:"${productId}"){
        practicalInformation {
          healthFormalities
          passportAndVisas
          includedInPackage
          excludedInPackage
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_TOUR_PRACTICAL_INFO,
      strictErrors: false,
    });
  },
};
